import { TripDetail } from "../components/trip/types";
import { API_BASE, getHeaders } from "./articleApi";

export const fetchTripDetail = async (tripId: string): Promise<TripDetail> => {
  const response = await fetch(
    `${API_BASE}/api/v1/user/trip/summary?tripId=${tripId}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  const json = await response.json();
  if (json.code !== 200 || !json.data) {
    throw new Error(json.message || "Failed to load trip");
  }
  return json.data;
};
